import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import ShapeSettingsModalView from '../component/ShapeSettingsModalView'
import { shapeColorSettings } from '../../DrawMap/settings'
import WeekSelect from '../../Form/SelectDashboard/types/WeekSelect/WeekSelect'
import { Input } from '../../Form/Input'
import { saveDraft } from '../../../Utils/draftStorage'
import styles from '../styles'

const ShapeSettingsModal = ({
  visible,
  onDelete,
  onUpdate,
  onClose,
  positionInsideParent,
  selectedOverlay,
  shouldPickWeek,
  countryCode,
  infoRows,
  saving,
  viewMode,
  children,
}) => {
  if (!visible || !selectedOverlay) return null
  const [colorCode, setColorCode] = useState(
    selectedOverlay.strokeColor || shapeColorSettings.fillColor,
  )
  const [date, setDate] = useState(
    selectedOverlay.payload && selectedOverlay.payload.date,
  )
  const [label, setLabel] = useState(
    selectedOverlay.payload && selectedOverlay.payload.label,
  )

  const handleSetColorValue = colorValue => {
    if (selectedOverlay) {
      selectedOverlay.set('strokeColor', colorValue)
      selectedOverlay.set('fillColor', colorValue)
      setColorCode(colorValue)
      onUpdate(selectedOverlay)
    }
  }

  const handleWeekChange = date => {
    setDate(date)
    selectedOverlay.set('payload', { ...selectedOverlay.payload, date })
    onUpdate(selectedOverlay, { date })
  }

  // Persist every keystroke to localStorage so an unsaved label survives a
  // crash / refresh / accidental modal close. Debounced via a setTimeout ref
  // so we coalesce bursts of typing.
  const labelDraftTimer = useRef(null)
  useEffect(
    () => () => {
      if (labelDraftTimer.current) clearTimeout(labelDraftTimer.current)
    },
    [],
  )

  const changeOverlayLabel = label => {
    selectedOverlay.set('payload', { ...selectedOverlay.payload, label })
    setLabel(label)
    if (labelDraftTimer.current) clearTimeout(labelDraftTimer.current)
    labelDraftTimer.current = setTimeout(() => {
      const scope =
        selectedOverlay.__draftScope ||
        (selectedOverlay.customId
          ? `drawmap:id:${selectedOverlay.customId}`
          : null)
      if (!scope) return
      try {
        saveDraft(scope, {
          customId: selectedOverlay.customId || null,
          color: selectedOverlay.fillColor,
          payload: { ...(selectedOverlay.payload || {}), label },
          // boundary intentionally omitted here — DrawMap's persistDraft owns
          // the geometry snapshot. We only checkpoint the in-progress label.
          partial: true,
        })
      } catch (e) {
        /* ignore storage errors */
      }
    }, 250)
  }

  return (
    <ShapeSettingsModalView
      onDelete={onDelete}
      onClose={onClose}
      setColorValue={handleSetColorValue}
      positionInsideParent={positionInsideParent}
      colorValue={colorCode}
      infoRows={infoRows}
      showDeleteButton={selectedOverlay.canBeDeleted}
      editingBlocked={selectedOverlay.editingBlocked}
      saving={saving}
    >
      {!selectedOverlay.editingBlocked && shouldPickWeek && (
        <WeekSelect value={date} onChange={handleWeekChange} />
      )}
      <Input
        label="Label"
        disabled={selectedOverlay.editingBlocked}
        value={label}
        onChange={e => changeOverlayLabel(e.target.value)}
      />
      {!viewMode && (
        <button onClick={() => onUpdate(selectedOverlay, { label })}>
          Save label
        </button>
      )}
      {selectedOverlay.link && (
        <Link style={styles.simpleText} to={selectedOverlay.link}>
          Mission {selectedOverlay.customId}
        </Link>
      )}
    </ShapeSettingsModalView>
  )
}

export default ShapeSettingsModal
